import React, { FC, useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../store/store";
import { Form, message, Tag } from "antd";
import ClaimIDManuallyId from "../../../components/patient/PreAuth/ClaimIDManuallyId";
import ManualStatus from "../../../components/patient/PreAuth/ManualStatusButton";
import ManualPortalStatus from "../../../components/patient/PreAuth/ManualPortalStatusButton";
import { PreAuthClaimAyushB } from "../../../components/patient/PreAuthClaim/ClaimAyushB/PreAuthClaimAyushB";
import { IDocumentFields } from "../../../interfaces/ICase";
import { IUploadReferral } from "../../../interfaces/IReferral";
import { Space } from "antd";
import {
  CloudDownloadOutlined,
  DeleteOutlined,
  EditOutlined,
  EyeOutlined,
} from "@ant-design/icons";
import { errorMessage, successMessage } from "../../../utils/notificationUtils";
import {
  deleteUploadedDocument,
  downloadDocument,
  enhancementService, getAllStarhealthDocumentsData,
} from "../../../apis/patientService";
import { UploadDocument } from "../../../models/visitSlice";
import { getVisitStageStates } from "../../../models/preAuthSlice";
import {
  getClaimDataForAyushB,
  getClaimFinanceForAyushB,
  getPortalDataForAyushB,
} from "../../../models/ayushmanBSlice";
import { Button } from "antd";
import {
  clearDeficiencyCheck,
  getDeficiencyQuestionData,
} from "../../../models/patientSlice";
import FilePreviewModal from "../../../components/patient/PreAuth-query/FilePreviewModal";
import RightSidePreviewModal from "../../../components/modals/RightSidePreviewModal";
import DocumentDeficiencyModal from "../../../components/patient/DocumentDeficiencyModal";
import UploadDocumentInPreAuth from "../../../components/patient/PreAuth/UploadDocumentInPreAuth";
import { fetchInvestigations } from "../../../apis/ayushmanBService";

const styles: Record<string, React.CSSProperties> = {
  mainContent: {
    border: "0.4px solid rgb(87, 87, 87)",
    gap: "15px",
    borderRadius: "16px",
    margin: "0px 0.5rem",
  },
  statusDesign: {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    gap: "20px",
    minWidth: "676px",
    maxHeight: "36px",
  },
  borderDesign: {
    minHeight: "64px",
    background: "rgb(243, 243, 243)",
    padding: "12px 35px", // Removed the semicolon and fixed the gap
    gap: "42px", // Added the gap as a separate property
    borderRadius: "16px 16px 0px 0px", // Fixed camelCase
    borderBottom: "1px solid rgb(166, 166, 166)",
    fontWeight: "600",
    fontSize: "16px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  filledBtn: {
    background: "#008B8B",
    border: "1px solid #008B8B",
    boxShadow: "0px 2px 8px 0px #00000040",
    borderRadius: "10px",
    padding: "12px 25px",
    textTransform: "uppercase",
    color: "white",
    marginRight: "0.8rem",
  },
  blankBtn: {
    color: "#008B8B",
    background: "white",
    border: "1px solid #008B8B",
    boxShadow: "0px 2px 8px 0px #00000040",
    borderRadius: "10px",
    padding: "12px 25px",
    marginRight: "0.8rem",
  },
  updateBtn: {
    position: "sticky",
    top: 0,
    backgroundColor: "white",
    zIndex: 998,
    padding: "10px 0",
    display: "flex",
    alignItems: "center",
    justifyContent: "end",
  },
  intimateSubmitBtn: {
    background: "#008B8B",
    // float: "right",
    marginRight: "0.8rem",
  },
  saveBtn: {
    color: "white",
    background: "#008B8B",
    border: "1px solid #008B8B",
    boxShadow: "0px 2px 8px 0px #00000040",
    borderRadius: "10px",
    padding: "12px 16px",
  },
  editBtn: {
    color: "#008B8B",
    background: "white",
    border: "1px solid #008B8B",
    boxShadow: "0px 2px 8px 0px #00000040",
    borderRadius: "10px",
    padding: "12px 16px",
  },
};

const STATUS = {
  INACTIVE: 4,
  COMPLETE: 8,
};

interface Document {
  id: number;
  type?: string;
  file?: any;
  documentId?: any;
  label?: string;
  labelId?: string | number;
  documentName?: string;
}

interface AyushBContainerProp {
  stepperForStatus: CallableFunction;
}

const PreAuthClaimContainerAyushB: React.FC<AyushBContainerProp> = ({ stepperForStatus }) => {
  const [form] = Form.useForm();
  const dispatch = useDispatch<AppDispatch>();
  const { patients, preAuth, preAuthClaim, hospital, auth, ayushBPreAuth } =
    useSelector((state: RootState) => state);

  const [manualStatusUpdateCount, setManualStatusUpdateCount] =
    useState<number>(0);
  const [activeStep, setActiveStep] = useState<number>(0);
  const [uploadFileModal, setUploadFileModal] = useState<boolean>(false);
  const [previewDocument, setPreviewDocument] = useState(false);
  const [documentOptions, setDocumentOptions] = useState([]);
  const [portalMetaDataId, setPortalMetaDataId] = useState<number | null>(null);
  const [documentUrl, setDocumentUrl] = useState<string>("");
  const [documentTypeList, setDocumentTypeList] = useState<{ [key: string]: Document[] }>({ ["hospital"]: [], ["others"]: [] });
  const [formattedDocumentTypeList, setFormattedDocumentTypeList] = useState<{ [key: string]: Document[] }>({ ["hospital"]: [], ["others"]: [] });
  // const [documentType, setDocumentType] = useState(null);
  // const [uploadedFileList, setUploadedFileList] = useState<any[]>([]);
  const [uploadedHospitalFileList, setUploadedHospitalFileList] = useState<IDocumentFields[]>([]);
  const [uploadedOtherFileList, setUploadedOtherFileList] = useState<IDocumentFields[]>([]);
  const [activeDocListType, setActiveDocListType] = useState<string>("");
  const [previewDocumentUrl, setPreviewDocumentUrl] = useState("");
  const [documentName, setDocumentName] = useState("");
  const [stageStatus, setStageStatus] = useState<number | null>(null);
  const [deficiencyModal, setDeficiencyModal] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [deficiencyCheckQuestions, setDeficiencyCheckQuestions] =
    useState(null);
  const [selectedDocument, setSelectedDocument] =
    useState<IDocumentFields | null>(null);

  const [selectedFile, setSelectedFile] = useState<IUploadReferral>({
    file: {},
    documentType: "",
  });
  const [previewFile, setPreviewFile] = useState({
    url: "",
    name: "",
    showUpload: false,
    documentType: "",
  });

  const currentActiveStage =
    preAuth?.stepperData?.visitStages?.[preAuth?.currentStep];
  const currentStageDetails = preAuth?.stepperData?.currentVisitStage;

  const patientStore = patients?.fetchBasicDetails;
  const caseId = patientStore?.casesResponse?.id;
  const visitId = patientStore?.visitInfoResponse?.id;
  const schemeMetaDataId = patientStore?.casesResponse?.schemeMetaDataId;
  const claimId = useMemo(
    () => ayushBPreAuth?.portalData?.casePreAuthOthersResponse?.claimId || "",
    [ayushBPreAuth?.portalData]
  );
  const caseClaimId = ayushBPreAuth?.claim?.caseData ? ayushBPreAuth?.claim?.caseData?.id : null

  const uploadedFileColumns = [
    {
      title: "S.No.",
      dataIndex: "key",
      key: "key",
      align: "center",
      width: 80,
      render: (text: any, records: any, index: number) => (
        <span style={{ fontWeight: "bold" }}>{index + 1}</span>
      ),
    },
    {
      title: "Document Type",
      dataIndex: "documentLabelType",
      key: "documentLabelType",
      align: "center",
      render: (text: string) => (
        <div style={{ textTransform: "initial", fontSize: "15px" }}>{text}</div>
      ),
    },
    {
      title: "Document Name",
      dataIndex: "documentName",
      key: "document",
      align: "center",
      render: (text: string) => (
        <div style={{ textTransform: "initial", fontSize: "15px" }}>{text}</div>
      ),
    },
    {
      title: "Deficiency Status",
      dataIndex: "deficiencyCheckStatus",
      key: "deficiency",
      align: "center",
      render: (text: boolean | null, record: IDocumentFields) => {
        if (record && record?.documentName) {
          setDocumentName(record?.documentName);
        }
        return text === true ? (
          <Tag color="green">Pass</Tag>
        ) : text === false ? (
          <Tag color="red">Fail</Tag>
        ) : text === null || text === undefined ? (
          <Button
            style={{
              backgroundColor: "#E0E0E0",
              borderRadius: "10px",
              color: "#222222",
              boxShadow: "0px -1px 4px 0px #00000040 inset",
            }}
            type="primary"
            onClick={() => {
              if (record?.documentType) {
                record?.documentUrl && record?.id && record && handleDeficiencyModalOpen(record?.documentUrl, record?.id, record);
              }
            }}
          >
            <span style={{ textTransform: "initial" }}>Check Deficiency</span>
          </Button>
        ) : null;
      },
    },
    {
      title: "Action",
      key: "action",
      align: "center",
      render: (_: any, record: IDocumentFields) => (
        <Space size="middle">
          <EyeOutlined
            style={{ color: "#008B8B", fontSize: "17px", cursor: "pointer" }}
            onClick={() => {
              handleOpen();
              record?.documentUrl &&
                handleSetDocumentUrl(
                  record?.documentUrl
                );
            }}
          />
          {/* <EditOutlined style={{ color: "#008B8B", fontSize: "17px", cursor: "pointer" }} /> */}
          <CloudDownloadOutlined
            style={{ color: "#008B8B", fontSize: "17px", cursor: "pointer" }}
            onClick={() =>
              handleDownloadDocument &&
              record?.documentName &&
              record?.documentUrl &&
              handleDownloadDocument(record?.documentName, record?.documentUrl)
            }
          />
          <DeleteOutlined
            style={{ color: "#008B8B", fontSize: "17px", cursor: "pointer" }}
            onClick={() =>
              record?.documentType &&
              record?.documentUrl &&
              handleDeleteDocument(record?.documentType, record?.documentUrl)
            }
          />
        </Space>
      ),
    },
  ];

  const fetchPostInvestigation = async (portalMetaDataId: number, data: any) => {
    if (portalMetaDataId && data) {
      try {
        const AllDocumentList = await fetchInvestigations(portalMetaDataId, data);
        let otherDocTypelist: Document[] = []
        if (Array.isArray(AllDocumentList) && AllDocumentList.length > 0) {
          otherDocTypelist = AllDocumentList?.map((item: any) => ({
            id: item?.documentMasterId,
            label: item?.investigationName,
            labelId: item?.documentMasterId,
          }));
        }

        setDocumentTypeList((prev) => ({
          ...prev,
          ["others"]: otherDocTypelist || []
        }))

      } catch (err) {
        errorMessage("Please, Try again after sometime");
      }
    }
  };


  const getAttachmentsWithValues2 = (attchmentData: any, key: string) => {
    const attachmentsWithValues: Array<IDocumentFields> = [];

    if (
      attchmentData
    ) {
      const attachments = attchmentData?.[
        "Document Details"
      ]?.filter(
        (doc: any) =>
          doc?.type === "document-upload" || doc?.type === "document-show"
      );
      attachments?.forEach((attachment: any) => {
        if (
          attachment?.documentsList &&
          attachment?.documentsList?.length > 0
        ) {
          attachment?.documentsList?.forEach((document: any) => {
            attachmentsWithValues.push({
              documentName: document?.documentName,
              documentType: document?.documentType,
              documentUrl: document?.documentUrl,
              id: document?.id,
              deficiencyCheckStatus: document?.deficiencyCheckStatus,
              documentLabelType: document?.documentLabelType,
            });
          });
        }
        // if (attachment?.data && attachment?.documentName) {
        //   attachmentsWithValues.push({
        //     documentName: attachment?.documentName,
        //     documentType: attachment?.labelId,
        //     documentUrl: attachment?.data,
        //     documentLabelType: attachment?.label,
        //     id: attachment?.documentId,
        //     deficiencyCheckStatus: attachment?.deficiencyCheckStatus,
        //     prefilledData: true,
        //   });
        // }
      });

      if (key == 'hospital') setUploadedHospitalFileList(attachmentsWithValues)
      if (key == 'other') setUploadedOtherFileList(attachmentsWithValues)
    }
  };

  const getAttachmentsWithValues = (attchmentData: any, key: string) => {
    if (attchmentData) {
      if (key == 'hospital') setUploadedHospitalFileList(attchmentData)
      if (key == 'other') setUploadedOtherFileList(attchmentData)
    }
  };

  const getDocumentOptions = (ayushBClaimData: any) => {
    if (ayushBClaimData) {
      const documentData = ayushBClaimData?.["Document Details"];
      const documentOptions = documentData.map((doc: any) => ({
        label: doc.label,
        value: doc.labelId,
      }));

      setDocumentOptions(documentOptions || []);
    }
  };

  const fetchDocuments = async (
    schemeMetaDataId: number,
    caseId: number,
    visitId: number
  ) => {
    if (schemeMetaDataId && caseId && visitId) {
      try {
        const AllDocumentList = await getAllStarhealthDocumentsData(
          caseId,
          visitId,
          schemeMetaDataId
        );
        setDocumentTypeList((prev) => ({
          ...prev,
          ["hospital"]: AllDocumentList?.["Claim"] || []
        }))
      } catch (err) {
        errorMessage("Please, Try again after sometime");
      }
    }
  };

  useEffect(()=>{
    if(documentTypeList?.hospital){
      const filteredOthers = documentTypeList?.hospital.filter(item => 
        !uploadedHospitalFileList.some(doc => doc.documentType === String(item.labelId))
    );

    setFormattedDocumentTypeList((prev) => ({
      ...prev,
      ["hospital"]: filteredOthers || []
    }))
    }

  },[uploadedHospitalFileList,documentTypeList?.hospital ])

  useEffect(()=>{
    if(documentTypeList?.others){
      const filteredOthers = documentTypeList?.others.filter(item => 
        !uploadedOtherFileList.some(doc => doc.documentType === String(item.labelId))
    );

    setFormattedDocumentTypeList((prev) => ({
      ...prev,
      ["others"]: filteredOthers || []
    }))
    }

  },[uploadedOtherFileList, documentTypeList?.others])

  useEffect(() => {
    if (schemeMetaDataId && caseId && visitId) {
      fetchDocuments(schemeMetaDataId, caseId, visitId);
    }
  }, [schemeMetaDataId, caseId, visitId]);

  useEffect(() => {
    if (ayushBPreAuth?.claim?.caseData) {
      if (ayushBPreAuth?.claim?.caseData) getAttachmentsWithValues(ayushBPreAuth?.claim?.caseData?.hospitalDocuments
        , "hospital");
      if (ayushBPreAuth?.claim?.caseData) getAttachmentsWithValues(ayushBPreAuth?.claim?.caseData?.otherDocuments
        , "other");

      // setClaimId(ayushBPreAuth?.portalData?.casePreAuthOthersResponse?.claimId || "");
    }
  }, [ayushBPreAuth?.claim?.caseData])

  useEffect(() => {
    if (ayushBPreAuth?.portalData?.casePreAuthOthersResponse?.treatmentPlansData?.length > 0 && portalMetaDataId) {
      const procedureCodeList = ayushBPreAuth?.portalData?.casePreAuthOthersResponse?.treatmentPlansData?.map((item: any) => {
        return item?.procedure?.id
      });

      const investigationPlayload = {
        procedureCodes: procedureCodeList,
        investigationStage: "Post"
      }
      fetchPostInvestigation(portalMetaDataId, investigationPlayload);
    }
  }, [ayushBPreAuth?.portalData, portalMetaDataId]);

  useEffect(() => {
    if (currentActiveStage?.visitStageId) {
      dispatch(
        getVisitStageStates({ visitStageId: currentActiveStage?.visitStageId })
      );
    }
  }, [currentActiveStage?.visitStageId]);

  useEffect(() => {
    handleGetportalMetaDataId();
  }, [schemeMetaDataId]);

  useEffect(() => {
    handleGetData();
    handleGetPortalData();
  }, [caseId, visitId, portalMetaDataId]);

  useEffect(()=>{
    if(claimId) {
      dispatch(
        getClaimFinanceForAyushB({ claimId: claimId })
      );
    }
  },[claimId])

  useEffect(() => {
    if (!currentActiveStage?.step || !currentStageDetails?.step) {
      setStageStatus(null);
      return;
    }

    if (currentActiveStage.step === currentStageDetails.step) {
      setStageStatus(currentStageDetails.stateId);
    } else if (currentActiveStage.step > currentStageDetails.step) {
      setStageStatus(STATUS.COMPLETE);
    } else {
      setStageStatus(STATUS.INACTIVE);
    }
  }, [currentActiveStage, currentStageDetails]);

  const isEditable = stageStatus !== STATUS.INACTIVE;

  const handleNext = () => {
    setActiveStep(activeStep + 1);
  };

  const handlePrevious = () => {
    setActiveStep(activeStep - 1);
  };

  const handleGetData = () => {
    if (caseId && visitId && portalMetaDataId) {
      dispatch(getClaimDataForAyushB({ caseId, visitId, portalMetaDataId }));
      stepperForStatus();
    }
  };

  const handleGetPortalData = () => {
    if (caseId && visitId) {
      dispatch(getPortalDataForAyushB({ caseId, visitId }));
    }
  };

  const handleGetportalMetaDataId = async () => {
    if (schemeMetaDataId) {
      const portalMetaData = await enhancementService.getPortalMetaData(
        schemeMetaDataId
      );
      setPortalMetaDataId(portalMetaData?.portalMetaDataIdsList[0]);
    }
  };

  const updateOrAddDocument = (
    uploadedDocumentUrl: Array<IDocumentFields>,
    documentRes: IDocumentFields
  ): Array<IDocumentFields> => {
    const updatedDocuments = [...uploadedDocumentUrl];
    const documentIndex = updatedDocuments.findIndex(
      (doc) => doc.documentType === documentRes.documentType
    );

    if (documentIndex !== -1) {
      updatedDocuments[documentIndex] = {
        ...updatedDocuments[documentIndex],
        documentName: documentRes?.documentName,
        documentUrl: documentRes?.documentUrl,
        deficiencyCheckStatus: documentRes?.deficiencyCheckStatus,
        id: documentRes?.id,
      };
    } else {
      updatedDocuments.push({
        documentType: documentRes.documentType,
        documentName: documentRes.documentName,
        documentUrl: documentRes.documentUrl,
        documentLabelType: documentRes?.documentLabelType,
        deficiencyCheckStatus: documentRes?.deficiencyCheckStatus,
        id: documentRes?.id,
      });
    }
    return updatedDocuments;
  };

  const handleFileChange =
    (documentType: string, docLabel: string | null = null) =>
      (e: any) => {
        const maxSize = 15 * 1024 * 1024;

        if (Array.isArray(e)) {
          return e;
        }
        // if (e?.file?.size > maxSize) {
        //   errorMessage("File Limit must be less than or equal to 15 MB");
        //   return;
        // }
        if (e?.fileList[0]) {
          setSelectedFile({ file: e?.fileList[0], documentType });
          setPreviewFile({
            url: URL.createObjectURL(e?.file),
            name: e.file.name,
            showUpload: true,
            documentType: documentType,
          });
          setUploadFileModal(true);
        }
        return e?.fileList;
      };

  const handleUploadDocument = async () => {
    const CollectPostData = new FormData();
     if (patients?.fetchBasicDetails?.casesResponse?.healthCareId) {
      CollectPostData.append(
        "hospitalId",
        patients?.fetchBasicDetails?.casesResponse?.healthCareId?.toString()
      );
    }
    if (patients?.fetchBasicDetails?.patientResponse?.id) {
      CollectPostData.append(
        "patientId",
        patients?.fetchBasicDetails?.patientResponse?.id?.toString()
      );
    }
    if (patients?.fetchBasicDetails?.casesResponse?.id) {
      CollectPostData.append(
        "caseId",
        patients?.fetchBasicDetails?.casesResponse?.id.toString()
      );
    }
    if (patients?.fetchBasicDetails?.visitInfoResponse?.id) {
      CollectPostData.append(
        "visitId",
        patients?.fetchBasicDetails?.visitInfoResponse?.id?.toString()
      );
    }
    CollectPostData.append("documentType", previewFile.documentType);

    if (selectedFile?.file) {
      CollectPostData.append("file", selectedFile?.file?.originFileObj as Blob);
    }

    try {
      const resp = await dispatch(
        UploadDocument({
          formData: CollectPostData,
          accessToken: auth.accessToken || "",
        })
      );
      if (UploadDocument.fulfilled.match(resp)) {
        const documentList = activeDocListType == "hospital" ? uploadedHospitalFileList : uploadedOtherFileList;
        // const updatedDocuments = updateOrAddDocument(
        //   documentList,
        //   resp?.payload
        // );
        const updatedDocuments = [...documentList, ...resp?.payload];
        if (resp?.payload?.length > 0) {
          message.success(
            `${resp?.payload?.[0]?.documentLabelType} uploaded successfully`
          );
          if (activeDocListType == 'hospital') setUploadedHospitalFileList(updatedDocuments)
          if (activeDocListType == 'other') setUploadedOtherFileList(updatedDocuments)
        } else {
          message.error("Please Upload Again");
        }
        setUploadFileModal(false);
      } else if (UploadDocument.rejected.match(resp)) {
        errorMessage("FAILED TO UPLOAD DOCUMENT");
      }
    } catch (error) {
      console.error("Failed to upload document:", error);
    }
  };

  const handleModalOpen = () => {
    setIsModalOpen(true)
  };

  const handleModalClose = () => {
    setIsModalOpen(false)
  };

  const handleCancel = () => {
    setUploadFileModal(false);
  };

  const handleCancelPreview = () => {
    setPreviewDocument(false);
  };

  const handleDownloadDocument = async (fileName: string, url: string) => {
    try {
      await downloadDocument(fileName, url);
      successMessage("Document Downloaded Successfully");
    } catch (err: any) {
      errorMessage("Please, Try again later");
    }
  };

  const handleDeleteDocument = async (docType: string, documentUrl: string) => {
    let deleteDocument
    if (activeDocListType == 'hospital') {
      deleteDocument = uploadedHospitalFileList?.find(
        (doc, index) => doc?.documentUrl === documentUrl
      );
    }
    if (activeDocListType == 'other') {
      deleteDocument = uploadedOtherFileList?.find(
        (doc, index) => doc?.documentUrl === documentUrl
      );
    }
    const deleteForm = {
      documentUrl: deleteDocument?.documentUrl,
      status: false,
      id: deleteDocument?.id,
    };
    let newUpdatedDocumentList;
    if (activeDocListType == 'hospital') {
      newUpdatedDocumentList = uploadedHospitalFileList?.filter(
        (doc, index) => doc?.documentUrl !== documentUrl
      );
    }
    if (activeDocListType == 'other') {
      newUpdatedDocumentList = uploadedOtherFileList?.filter(
        (doc, index) => doc?.documentUrl !== documentUrl
      );
    }
    // dispatch(setUploadedDocumentUrl(newUpdatedDocumentList));
    if (deleteDocument?.documentUrl) {
      const res = await deleteUploadedDocument(deleteForm);
      if (res) {
        message.success("Document Deleted Successfully!")
        if (activeDocListType == 'hospital') setUploadedHospitalFileList(newUpdatedDocumentList || [])
        if (activeDocListType == 'other') setUploadedOtherFileList(newUpdatedDocumentList || [])
      }

    }
  };

  const handleSetDocumentUrl = (url: string) => {
    setDocumentUrl(url);
  };

  const handleOpen = () => {
    setPreviewDocument(true);
  };

  const fetchDeficiencyData = async (
    selectedDocument: any,
    selectedDocumentId: any
  ) => {
    try {
      if (selectedDocumentId) {
        dispatch(clearDeficiencyCheck());
        // const firstRes = await dispatch(
        //   getDeficiencyQuestions(selectedDocumentId)
        // );

        if (selectedDocument?.id) {
          const secondRes = await dispatch(
            getDeficiencyQuestionData(selectedDocument?.id)
          );
        }
      }
    } catch (err) {
      errorMessage("Please, Try again after sometime");
      // setSelectedDocumentId(null);
      setSelectedDocument(null);
    }
  };

  const handleDeficiencyModalOpen = async (
    documentUrl: string,
    documentId: number,
    document: IDocumentFields
  ) => {
    await fetchDeficiencyData(document, documentId);
    setPreviewDocumentUrl(documentUrl);
    // setSelectedDocumentId(documentId);
    setDeficiencyModal(true);
    setSelectedDocument(document);
  };

  const handleDeficiencyModalAfterSave = async (
    documentUrl: string,
    documentId: number,
    field: any
  ) => {
    const document = {
      id: field?.documentId,
      documentName: field?.documentName,
      documentType: field?.labelId,
      documentUrl: field?.data,
      documentLabelType: field?.label,
      deficiencyCheckStatus: field?.deficiencyCheckStatus,
    };
    await fetchDeficiencyData(document, documentId);
    setPreviewDocumentUrl(documentUrl);
    // setSelectedDocumentId(documentId);
    setDeficiencyModal(true);
    setSelectedDocument(document);
  };

  const closeDeficiencyModal = () => {
    setDeficiencyModal(false);
    // setSelectedDocumentId(null);
    setSelectedDocument(null);
  };

  return (
    <div style={styles.mainContent}>
      <div style={styles.borderDesign}>
        <span style={{ fontSize: "20px", alignContent: "center" }}>
          CLAIM
        </span>
        <div style={styles.statusDesign}>
          <ClaimIDManuallyId handlePortalData={handleGetData} />

          {currentActiveStage?.visitStageId &&
            patientStore?.visitInfoResponse?.id && (
              <ManualStatus
                stateData={
                  preAuth?.stageAllState?.[currentActiveStage?.visitStageId] ||
                  null
                }
                status={stageStatus}
                visitId={patientStore?.visitInfoResponse?.id}
                visitStageId={currentActiveStage?.visitStageId}
                isUpdateable={isEditable}
                // setManualStatusUpdateCount={setManualStatusUpdateCount}
              />
            )}
          {patientStore?.visitInfoResponse?.id && (
            <ManualPortalStatus
              // statusList={preAuth?.schemePortalStatusList || []}
              status={preAuth?.portalData?.portalStatus || "-"}
              visitId={patientStore?.visitInfoResponse?.id}
              isUpdateable={isEditable}
              // setManualStatusUpdateCount={setManualStatusUpdateCount}
            />
          )}
        </div>
      </div>
      <PreAuthClaimAyushB
        activeStep={activeStep}
        handleNext={handleNext}
        handlePrevious={handlePrevious}
        form={form}
        // setDocumentType={setDocumentType}
        // documentType={documentType}
        setActiveDocListType={setActiveDocListType}
        activeDocListType={activeDocListType}
        setUploadedHospitalFileList={setUploadedHospitalFileList}
        setUploadedOtherFileList={setUploadedOtherFileList}
        uploadedHospitalFileList={uploadedHospitalFileList}
        uploadedOtherFileList={uploadedOtherFileList}
        handleUploadFile={handleFileChange}
        uploadedFileColumns={uploadedFileColumns}
        stageStatus={stageStatus}
        portalMetaDataId={portalMetaDataId}
        documentOptions={documentOptions}
        handleGetData={handleGetData}
        handleModalOpen={handleModalOpen}
      />
      <FilePreviewModal
        isVisible={uploadFileModal}
        onClose={handleCancel}
        fileUrl={previewFile.url}
        fileName={previewFile.name}
        documentType={previewFile.documentType}
        handleUpload={handleUploadDocument}
        showUploadButton={previewFile.showUpload}
        key={selectedFile?.file?.uid || "no-file"}
        isLoading={preAuthClaim?.isLoading}
      />
      <RightSidePreviewModal
        key={documentUrl}
        documentUrl={documentUrl}
        handleCancel={handleCancelPreview}
        open={previewDocument}
      />
      <DocumentDeficiencyModal
        key={previewDocumentUrl}
        closeDeficiencyModal={closeDeficiencyModal}
        deficiencyModal={deficiencyModal}
        documentUrl={previewDocumentUrl}
        documentName={documentName}
        handleDownloadDocument={handleDownloadDocument}
        deficiencyQuestions={patients?.deficiencyCheckQuestions}
        selectedDocument={selectedDocument}
        setUploadedDocumentUrl={
          activeDocListType == "hospital" ?
            setUploadedHospitalFileList :
            setUploadedOtherFileList
        }
      // type={"claim"}
      />
      <UploadDocumentInPreAuth
        // title="Confirm Document Upload"
        visible={isModalOpen}
        documentTypes={formattedDocumentTypeList[activeDocListType]}
        setDocumentTypes={setDocumentTypeList}
        // activeDocListType={activeDocListType}
        // onOk={handleModalOk}
        onCancel={handleModalClose}
        setDocumentUrls={
          activeDocListType == "hospital" ?
            setUploadedHospitalFileList :
            setUploadedOtherFileList
        }
      />
    </div>
  );
};

export default PreAuthClaimContainerAyushB;
